import { createSelector } from 'reselect';

import { getDateFilterFromQueryParams } from '../../util';
import { getTimeFilterParams } from '../../api-adapter';
import * as urlQueryString from './../../urlQueryString';
import { ownerFilterSelector } from '../root-causes/selectors';
import { OWNER_FILTER_SCOPES } from '../../constants';

export const failureAnalysisStore = (store) => store.apps.analytics.failureAnalysis;
const filtersStore = (store) => store.apps.analytics.filters;
export const userStore = (store) => store.user;
const routerLocation = (store) => store.router.location;

export const failureAnalysisSelector = createSelector(
  failureAnalysisStore,
  filtersStore,
  userStore,
  (failureAnalysis, filters, user) => ({
    loadingData: failureAnalysis.get('loadingData'),
    items: failureAnalysis.get('items'),
    itemsCount: failureAnalysis.get('itemsCount'),
    pagination: failureAnalysis.get('pagination'),
    selectedDateFilter: filters.get('selectedDateFilter'),
    jobOwnersFilter: failureAnalysis.get('jobOwnersFilter'),
    userIsAdmin: user.isAdmin(),
    getTestsError: failureAnalysis.get('getTestsError'),
    filters: filters.get('filters'),
  }),
);

export const testsSelector = createSelector([
  failureAnalysisStore,
  filtersStore,
  ownerFilterSelector,
],
(failureAnalysis, filters, selectedOwner) => ({
  ...selectedOwner,
  selectedDate: filters.get('selectedDateFilter'),
}));

export const testsParamSelector = createSelector([
  failureAnalysisStore,
  filtersStore,
  routerLocation,
  ownerFilterSelector,
  (store, options) => options,
],
(failureAnalysis, filters, location, selectedOwner, options = {}) => {
  const { isQueryStringFilter, dateBase } = options;
  const { dateFilter } = urlQueryString.getAll(location);
  const defaultParams = {
    ...selectedOwner,
    ...getTimeFilterParams(filters.get('selectedDateFilter'), dateBase),
  };

  if (isQueryStringFilter) {
    return {
      ...defaultParams,
      ...(dateFilter && getTimeFilterParams(
        getDateFilterFromQueryParams({ dateFilter }), dateBase,
      )),
    };
  }

  return defaultParams;
});

export const filterParamSelector = createSelector([
  userStore,
  routerLocation,
], (user, location) => ([
  user,
  location,
]));

export const queryParamSelector = createSelector([
  ownerFilterSelector,
  (store, options) => options,
],
(selectedOwner, options = {}) => ({
  ...selectedOwner,
  ...urlQueryString.extractQueryStringFromAPI(options),
}));

export const defaultFilterSelector = createSelector([
  userStore,
], (user) => {
  if (user.isOrgAdmin() || user.isJobTeamSharingEnabled()) {
    return { filter: { owners: [OWNER_FILTER_SCOPES.ORGANIZATION] } };
  }

  if (user.getUserTeamId()) {
    return { filter: { owners: [OWNER_FILTER_SCOPES.TEAM] } };
  }

  return { filter: { owners: [OWNER_FILTER_SCOPES.MYSELF] } };
});
